// OBD / check-engine status for the live popups. Everything here is gated
// server-side on obd_present, so it is false/0 for phones and non-OBD trackers.
// `show` is true only when there is something to warn about, and only for
// vehicle-kind subjects, so the icon never appears on a person/pet/item.
//
// What counts as a fault lives in obdFault.js, which is import-free and unit
// tested. The short version: dtc_count is the PENDING count and must never
// raise a warning; stored_dtc_count is what the lamp actually reports.

import {subjectKindOf} from "@/composables/subjectKind";
import {isPhoneDevice} from "@/composables/usePowerSourceIcon";
import {
    milOn, confirmedFaultCount, pendingCodeCount, hasConfirmedFault, faultHint,
} from "@/composables/obdFault";

export function obdStatus(device) {
    const isVehicle = subjectKindOf(device) === "vehicle";
    return {
        isVehicle,
        // Exposed so a caller gating on obd_present can keep the same
        // belt-and-suspenders phone check that `show` applies below.
        isPhone: isPhoneDevice(device),
        obdPresent: device?.obd_present === true,
        mil: milOn(device),
        dtcCount: pendingCodeCount(device),
        storedDtcCount: confirmedFaultCount(device),
        // Belt and suspenders: never on a phone (server already zeroes MIL/DTC when
        // obd_present is false, but keep the invariant enforced client-side too).
        show: isVehicle && !isPhoneDevice(device) && hasConfirmedFault(device),
    };
}

// Short tooltip/label for the check-engine affordance.
export function obdHint(device) {
    return faultHint(device);
}
